import * as ActionTypes from './types.action';

export const submitReview = ({itemId, rating, comment}) => ({
  type: ActionTypes.SUBMIT_REVIEW_REQUESTED,
  itemId,
  rating,
  comment,
});

export const resetSubmitReview = () => ({
  type: ActionTypes.RESET_SUBMIT_REVIEW,
});
